import React from "react";
import CustomerTable from "../components/CustomerTable";
import Layout from "../components/Layout";

const CustomersPage: React.FC = () => {
    return (
        <Layout>
            <CustomerTable />
        </Layout>
    );
};

export default CustomersPage;

